<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <ul class="text-tip">
                    <li>
                        本次申請變更之要保人行動電話及E-mail，將同時更新以您為要保人於本公司所投保之所有個人險有效及停效保單。
                        <!-- 本次申請變更之要保人行動電話及E-mail，將同時更新以您為要保人於本公司所投保之所有個人險(含MG系列保單)有效及停效保單。 -->
                    </li>
                </ul>
                <div
                    v-for="(item, index) in afterData"
                    :key="index"
                >
                    <ChangeBeforeAfter
                        v-if="item.joinVal!==beforeData[index]?.joinVal"
                        :title="item.title"
                    >
                        <template #before>
                            <p v-if="beforeData[index]?.addr&&beforeData[index]?.addr!==''">
                                {{ beforeData[index].addr }}
                            </p>
                            <p v-if="item.phone&&item.phone!==''">
                                <span v-if="beforeData[index]?.telAreaCode">
                                    {{ `${beforeData[index].telAreaCode}-` }}
                                </span>
                                <span>
                                    {{ beforeData[index].tel }}
                                </span>
                                <span v-if="beforeData[index]?.telExt">
                                    分機 {{ beforeData[index].telExt }}
                                </span>
                            </p>
                            <p>
                                <span v-if="beforeData[index]?.mobileCountry&&beforeData[index]?.mobileCountry!=='886'">
                                    (+{{ beforeData[index].mobileCountry }})
                                </span>
                                {{ beforeData[index]?.mobile }}
                            </p>
                            <p
                                v-if="beforeData[index]?.email && beforeData[index]?.email!==''"
                                class="break-all"
                            >
                                {{ beforeData[index].email }}
                            </p>
                        </template>
                        <template #after>
                            <p>
                                {{ item.addr }}
                            </p>
                            <p v-if="item.phone&&item.phone!==''">
                                <span v-if="item.telAreaCode">
                                    {{ `${item.telAreaCode}-` }}
                                </span>
                                <span>
                                    {{ item.tel }}
                                </span>
                                <span v-if="item.telExt">
                                    分機 {{ item.telExt }}
                                </span>
                            </p>
                            <p>
                                <span v-if="item.mobileCountry&&item.mobileCountry!=='886'">
                                    (+{{ item.mobileCountry }})
                                </span>
                                {{ item.mobile }}
                            </p>
                            <p
                                v-if="item.email && item.email!==''"
                                class="break-all"
                            >
                                {{ item.email }}
                            </p>
                        </template>
                    </ChangeBeforeAfter>
                </div>
                <div v-if="doAllianceChain">
                    <h4 class=" mb-2 mt-4  md:mt-5">
                        轉送保全聯盟鏈
                    </h4>
                    <p>
                        <span v-if="allianceChain">同意授權本公司將變更資料，傳送至以下保險公司申辦相同項目變更</span>
                        <span v-else>不同意授權本公司將變更資料，傳送至其他保險公司申辦相同項目變更</span>
                    </p>
                    <div v-if="allianceChain?.life">
                        <h5 class="mt-4 mb-2 md:mt-5">
                            壽險公司
                        </h5>
                        <p>
                            {{ allianceChain.life }}
                        </p>
                    </div>
                    <div v-if="allianceChain?.property">
                        <h5 class="mt-4 mb-2 md:mt-5">
                            產險公司
                        </h5>
                        <p>
                            {{ allianceChain.property }}
                        </p>
                    </div>
                </div>
            </template>
        </CollapseConfirmData>
    </div>
</template>
<script>
import { toRef, computed, ref } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ChangeBeforeAfter from '@/components/template/ChangeBeforeAfter.vue';

export default {
    name: 'BCData',
    components: {
        CollapseConfirmData,
        ChangeBeforeAfter,
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const code = ref('BC');
        // 被保人區塊資訊 insuredInfo // 收費區塊資訊 chargeInfo
        // 要保人區塊資訊 applicantInfo // 要保人行動電話 mobile // 要保人Email email
        const data = toRef(props, 'result');

        const beforeData = computed(() => {
            const ary = data.value.before;
            return makeBCData(ary);
        });
        const afterData = computed(() => {
            const ary = data.value.after;
            return makeBCData(ary);
        });
        const blockNameList = {
            insuredInfo: '被保險人住所/電話/E-mail',
            chargeInfo: '收費地址/電話',
            applicantInfo: '要保人住所(戶籍地址)/電話',
            mobile: '要保人行動電話',
            email: '要保人E-mail',
        };
        if (!data.value.insuredAuth) {
            delete blockNameList.insuredInfo;
        }
        const makeBCData = (ary) => {
            ary.mobileCountry = ary.mobileCountry === '' ? '886' : ary.mobileCountry;
            if (ary.insuredInfo) {
                ary.insuredInfo.mobileCountry = ary.insuredInfo.mobileCountry === '' ? '886' : ary.insuredInfo.mobileCountry;
            }
            const newAry = [];
            const keys = Object.keys(blockNameList);

            keys.forEach(key => {
                let i = {};
                const val = ary[key];
                if (key === 'mobile') {
                    i = {
                        [key]: val,
                        mobileCountry: ary.mobileCountry,
                    };
                } else if (key === 'email') {
                    i = { [key]: val };
                } else {
                    i = {
                        ...val,
                        addr: val.city + val.cityArea + val.address,
                        phone: val.telAreaCode + val.tel + val.telExt,
                    };
                }
                const joinVal = Object.values(i).join('');

                i = { ...i, id: key, title: blockNameList[key], joinVal };
                newAry.push(i);
            });
            return newAry;
        };

        const allianceChain = ref(data.value.allianceChainResult);
        const doAllianceChain = ref(data.value.doAllianceChain);
        const removeService = () => {
            emit('removeService', code.value);
        };

        return {
            removeService,
            code,
            allianceChain,
            doAllianceChain,
            beforeData,
            afterData,
        };
    },
};
</script>
